import { render } from "./Landing.vue?vue&type=template&id=fe87b3da&scoped=true"
import script from "./Landing.vue?vue&type=script&lang=js"
export * from "./Landing.vue?vue&type=script&lang=js"

import "./Landing.vue?vue&type=style&index=0&id=fe87b3da&scoped=true&lang=css"

import exportComponent from "/home/runner/work/codehat-inprog-front-vue3/codehat-inprog-front-vue3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fe87b3da"]])

export default __exports__